<template>
  <b-form @submit.prevent="submit" @reset="resetForm" class="row mb-20 rounded bg-dark-blue py-3 display-sm-none">
    <div class="col-12 col-lg-3 mb-3 mb-lg-0" :class="{ 'col-lg-4': hidePayers }">
      <p class="mb-2 text-left text-white">Reference Number</p>
      <b-form-group
        label="Document Reference Number"
        label-for="initial-sort-select"
        class="mb-0"
        label-sr-only
      >
        <b-form-input v-model="formData.service_reference" placeholder="Enter Document Reference Number" name="service_reference"></b-form-input>
      </b-form-group>
    </div>

    <div class="col-12 col-lg-4 mb-3 mb-lg-0 custom-date-picker" :class="{ 'col-lg-5': hidePayers }">
      <div class="row">
        <div class="col-12 text-left text-white">
          <label for="example-datepicker" class="date-range-label">Date Range</label>
        </div>

        <div class="col-6 d-flex align-items-center">
          <span class="mr-1 text-white date-range-field-label">From</span>
          <b-form-datepicker 
            v-model="formData.start_date"
            class="mb-2"
            value-as-date
            :date-format-options="{ month: 'numeric', day: 'numeric', year: 'numeric' }"
            today-button
            reset-button
            close-button
            name="start_date"
          ></b-form-datepicker>
        </div>

        <div class="col-6 d-flex align-items-center">
          <span class="mr-1 text-white date-range-field-label">To</span>
          <b-form-datepicker
            v-model="formData.end_date"
            class="mb-2"
            value-as-date
            :date-format-options="{ month: 'numeric', day: 'numeric', year: 'numeric' }"
            today-button
            reset-button
            close-button
            name="end_date"
          ></b-form-datepicker>
        </div>
      </div>
    </div>
  
    <div class="col-12 col-lg-2 mb-3 mb-lg-0" v-if="!hidePayers">
      <p class="mb-2 text-left text-white">Payer</p>
      <b-form-group
        label="Initial sort"
        label-for="initial-sort-select"
        class="mb-0"
        label-sr-only
      >
        <b-form-select
          :options="payersListing"
          v-model="formData.payer_account"
          value-field="payer_account.id"
          text-field="payer_account.name"
          name="payer_account"
        >
          <template #first>
            <option value="null">Select Payer</option>
          </template>
        </b-form-select>
      </b-form-group>
    </div>

    <div class="col-12 col-lg-3 mb-3 mb-lg-0 d-flex align-items-end pb-2">
      <b-button variant="primary" class="w-100 mr-1" type="submit" :disabled="!dirty">Filter</b-button>
      <b-button variant="success" class="w-100 ml-1" type="reset" xdisabled="!dirty">
        <i class="fas fa-sync-alt"></i>
        Reset
      </b-button>
    </div>
  </b-form>
    
</template>
<script>
import store from '../store';
import TransactionAPI from '../api/transactions_api';
import { tableMixin } from '../utils/table.mixin';

export default {
  props: ['filtersSubmit', 'reset', 'hidePayers'],
  mixins: [
    tableMixin
  ],
  data: () => ({
    formData: {
      service_reference: null,
      start_date: null,
      end_date: null,
      payer_account: null
    },
    dirty: false
  }),
  mounted() {
    TransactionAPI.methods.getPayers();
  },
  methods: {
    submit(event) {
      const { service_reference, start_date, end_date, payer_account } = Object.fromEntries(new FormData(event.target));    
      console.log('filtersSubmit', service_reference, start_date, end_date, payer_account);
      const params = {
        service_reference: service_reference,
        start_date: start_date,
        end_date: end_date,
        payer_account: payer_account,
        //page: 1// 1,2,3,4,5....
        //page_size: 10
      };

      this.filterProperties = {
        ...this.filterProperties,
        ...params
      };

      if (this.dirty) {
        this.$emit('filtersSubmit', params);
      }
    },
    resetForm(event) {
      if (this.dirty) {
        event.target.reset();
        
        for (var prop in this.formData) { 
          this.formData[prop] = null;
        }

        this.$emit('reset');
        this.dirty = false;
      }
    }
  },
  computed: {
    filterProperties: {
      get: function() {
        return store.state.filterProperties;
      },
      set: function(newValue) {
        store.state.filterProperties = newValue;
      } 
    },
    payersListing: {
      get: function() {
        return store.state.payersListing;
      },
      set: function(newValue) {
        store.state.payersListing = newValue;
      } 
    },
  },
  watch: {
    formData: {
      handler(newVal, oldVal) {
        this.dirty = true;
      },
      deep: true
    }
  }
};
</script>
